import { Controller } from 'stimulus'
import Swal from 'sweetalert2'

export default class extends Controller {

  async openPopupForm(e) {
    const dealId = e.currentTarget.dataset.id
    const { value: formValue } = await Swal.fire({
      title: '¿Deseas Incubar al Cliente?',
      text: 'Selecciona la fecha',
      html:
        '<input type="date" id="incubate-date-input" class="swal2-input">',
      focusConfirm: false,
      preConfirm: () => {
        return document.getElementById('incubate-date-input').value
      }
    })
    
    if (formValue) {
      console.log(formValue)
      Rails.ajax({
        type: "patch",
        dataType: 'json',
        url: '/associate/deals/' + dealId,
        data: `deal[incubation_end_date]=${formValue}&deal[status]=incubated`,
        error: function(data) { alert(data) }
      })
    }
  }
}